import * as React from 'react'
import { alpha } from '@mui/material/styles'
import Box from '@mui/material/Box'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TablePagination from '@mui/material/TablePagination'
import TableRow from '@mui/material/TableRow'
import TableSortLabel from '@mui/material/TableSortLabel'

import Typography from '@mui/material/Typography'
import Paper from '@mui/material/Paper'
import Checkbox from '@mui/material/Checkbox'
import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import DeleteIcon from '@mui/icons-material/Delete'
import FilterListIcon from '@mui/icons-material/FilterList'
import { visuallyHidden } from '@mui/utils'
import CheckIcon from '@mui/icons-material/Check'
import SaveIcon from '@mui/icons-material/Save'
import * as XLSX from 'xlsx'
import { Data } from '../../../types/data'
import { EnhancedTableProps, EnhancedTableToolbarProps, headCells, Order, Tableprops } from '../../../types/table'
import { useSubmitDataMutation, useSubmitStatusMutation } from '../../../services/goroskop'
import StarIcon from '@mui/icons-material/Star'
import EditIcon from '@mui/icons-material/Edit'
import AccountBoxIcon from '@mui/icons-material/AccountBox'
import { Link } from 'react-router-dom'
import ArticleIcon from '@mui/icons-material/Article'
import {
  Avatar,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SvgIcon,
  TextField,
  Chip,
  Divider,
} from '@mui/material'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import dayjs from 'dayjs'
import { normalizeDate } from '../../../utils/date'
import { PhoneLink } from '../../../utils/phone'
import { useSnackbar } from 'notistack'
import { useAppDispatch } from '../../../hooks/hooks'
import CalendarTodayIcon from '@mui/icons-material/CalendarToday'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutlineOutlined'
import RestoreFromTrashIcon from '@mui/icons-material/RestoreFromTrash'
import restrictRole from '../../../functions/restrictRole'
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges'
import cloneDeep from 'lodash.clonedeep'
import T from '../../quiz/OnlyText'
import { getCookie } from '../../../functions/Cookie'
import SettingsIcon from '@mui/icons-material/Settings'
import { SelectChangeEvent } from '@mui/material/Select'
import FormControlLabel from '@mui/material/FormControlLabel'
import vipStatus from '../../../functions/vipStatus'

import '../../../table.css'
import { ReactComponent as Counter1 } from '../../../assets/numbers/Counter1.svg'
import { ReactComponent as Counter2 } from '../../../assets/numbers/Counter2.svg'
import { ReactComponent as Counter3 } from '../../../assets/numbers/Counter3.svg'
import { ReactComponent as Counter4 } from '../../../assets/numbers/Counter4.svg'
import { ReactComponent as Counter5 } from '../../../assets/numbers/Counter5.svg'
import { ReactComponent as Counter6 } from '../../../assets/numbers/Counter6.svg'
import { ReactComponent as Counter7 } from '../../../assets/numbers/Counter7.svg'
import { ReactComponent as Counter8 } from '../../../assets/numbers/Counter8.svg'
import { ReactComponent as Counter9 } from '../../../assets/numbers/Counter9.svg'

function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
  if (b[orderBy] < a[orderBy]) {
    return -1
  }
  if (b[orderBy] > a[orderBy]) {
    return 1
  }
  return 0
}

function getComparator<Key extends keyof any>(
  order: Order,
  orderBy: Key
): (a: { [key in Key]: any } | any, b: { [key in Key]: any } | any) => number {
  if (orderBy === 'next_contact_date') {
    return (a: any, b: any) => {
      const aDate = normalizeDate(a?.next_contact_date)
      const bDate = normalizeDate(b?.next_contact_date)

      if (!aDate && !bDate) {
        return Number(b?.id || 0) - Number(a?.id || 0)
      }
      if (!aDate) return 1
      if (!bDate) return -1

      const diff = aDate.localeCompare(bDate)
      if (diff !== 0) {
        return order === 'desc' ? -diff : diff
      }
      return Number(b?.id || 0) - Number(a?.id || 0)
    }
  }

  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy)
}

const EnhancedTableToolbar = (props: EnhancedTableToolbarProps) => {
  const { numSelected, nameOfTable, modInfo } = props
  //console.log('props',props);
  const role = String(getCookie('role'))
  let modId = null

  if (role == 'ok_admin') {
    if (modInfo && modInfo[0] && modInfo[0].id) modId = modInfo[0].id
  }

  const editModeratorLink = modId ? (
    <Link to={`../profile/${modId}`}>
      <EditIcon />
    </Link>
  ) : (
    ''
  )

  //const role = String(getCookie('role'));

  const customTitle = (nameOfTable: string | undefined) => {
    switch (nameOfTable) {
      case 'Линия 1':
        return 'Главный модератор'
        break
      case 'Линия 3':
        return (
          <>
            [Линия 3] Отдел обслуживания
            {role == 'ok_admin' ? (
              <Link to={'/admin/linethreecfg'}>
                <SettingsIcon color="primary" />
              </Link>
            ) : null}
          </>
        )
        break
      default:
        return nameOfTable
        break
    }
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        px: { xs: 1.5, sm: 2.5 },
        py: 1.25,
        borderBottom: '1px solid',
        borderColor: 'divider',
        ...(numSelected > 0 && {
          bgcolor: (theme) => alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity),
        }),
      }}
    >
      {numSelected > 0 ? (
        <Typography sx={{ flex: '1 1 100%', fontWeight: 600 }} color="inherit" variant="subtitle1" component="div">
          Выбрано записей: {numSelected}
        </Typography>
      ) : (
        <Typography
          sx={{ flex: '1 1 100%', fontWeight: 600, fontSize: '1.05rem', color: 'text.primary' }}
          variant="h6"
          id="tableTitle"
          component="div"
        >
          {customTitle(nameOfTable)} {editModeratorLink}
        </Typography>
      )}
      {numSelected > 0 ? (
        <Tooltip title="Delete">
          <IconButton size="small">
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <Tooltip title="Filter list">
          <IconButton size="small">
            <FilterListIcon />
          </IconButton>
        </Tooltip>
      )}
    </Box>
  )
}

function EnhancedTableHead(props: EnhancedTableProps) {
  const { order, orderBy, onRequestSort } = props

  const createSortHandler = (property: keyof Data) => (event: React.MouseEvent<unknown>) => {
    onRequestSort(event, property)
  }

  const wideArr = [
    { id: 'next_contact_date', label: 'Контрольная дата контакта' },
    { id: 'id', label: 'Админу' },
    { id: 'id', label: 'Экспорт' },
    { id: 'id', label: 'На обработку' },
    { id: 'id', label: 'Главному модератору' },
    { id: 'id', label: 'На модерацию' },
    { id: 'id', label: 'Архив' },
    { id: 'id', label: 'Модерация' },
    { id: 'id', label: 'Информация' },
    { id: 'id', label: 'В корзину' },
    { id: 'id', label: 'Удалить' },
  ]

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell, index) => (
          <TableCell
            key={`${headCell.id}-${index}`}
            align="left"
            sx={{
              ...(wideArr.some((el) => el.id === headCell.id)
                ? { maxWidth: '80px', padding: '1px 4px' }
                : { maxWidth: '20px', padding: '1px 4px' }),
              ...((index === 0 || index === headCells.length - 2) && { paddingLeft: '10px !important' }),
            }}
            sortDirection={headCell.label && orderBy === headCell.id ? order : false}
          >
            {headCell.label ? (
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : 'asc'}
                onClick={createSortHandler(headCell.id)}
              >
                {headCell.label}
                {orderBy === headCell.id ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                  </Box>
                ) : null}
              </TableSortLabel>
            ) : null}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  )
}

const EnhancedTable: React.FC<Tableprops> = ({
  data,
  nameOfTable,
  modInfo,
  exId,
  defaultOrderBy = 'defer',
  defaultOrder = 'asc',
}) => {
  //i used deep clone for changes inside array (it was refs on value merrory, but not clone)

  const [deepCloneData, setDeepCloneData] = React.useState(cloneDeep(data))

  React.useEffect(() => {
    setDeepCloneData(cloneDeep(data))
  }, [data])

  // --- send to other moderation multi-selected ---
  const [targetmod, setTargetmod] = React.useState('')
  const handleChangeMod = (event: SelectChangeEvent) => {
    setTargetmod(event.target.value)
  }
  const modId = modInfo && modInfo[0] && modInfo[0].id ? modInfo[0].id : null
  const modList = [
    { status: '1', id: '103' },
    { status: '2', id: '104' },
    { status: '3', id: '106' },
    { status: '4', id: '107' },
    { status: '5', id: '108' },
    { status: '6', id: '109' },
    { status: '7', id: '110' },
    { status: '8', id: '111' },
    { status: '9', id: '112' },
  ]
  const printMenuItems = (active: string | null) => {
    let accesIds = ['103', '104', '106', '107', '108', '109', '110', '111', '112']
    if (active && accesIds.includes(active)) {
      let tmpMenu: string[] = []
      modList.forEach((mod) => {
        if (mod.id !== active) {
          tmpMenu.push(mod.status)
        }
      })
      return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <FormControl size="small" sx={{ minWidth: 170 }}>
            <InputLabel id={'mod-select-small-label-' + active}>{nameOfTable || 'Модерация'}</InputLabel>
            <Select
              labelId={'mod-select-small-label-' + active}
              id={'mod-select-small-' + active}
              value={targetmod}
              label={nameOfTable || 'Модерация'}
              onChange={handleChangeMod}
            >
              {tmpMenu.map((item) => (
                <MenuItem key={item} value={item}>
                  Модерация №{item}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Button
            variant="contained"
            size="medium"
            disableElevation
            sx={{ height: 40, px: 2, textTransform: 'uppercase', fontWeight: 600 }}
            onClick={(event) => {
              sendToModerationNum(event, active)
            }}
          >
            Отправить
          </Button>
        </Box>
      )
    }
    return []
  }
  const sendToModerationNum = (event: React.MouseEvent<HTMLButtonElement>, from: string | null) => {
    if (selected.length > 0 && targetmod !== '') {
      /*console.log('sendToModerationNum', {
          event: event.target,
          from: from,
          to:targetmod,
          selected: selected
      })*/
      let fd = new FormData()
      fd.append('ids', JSON.stringify(selected))
      fd.append('status', targetmod)
      //console.log(fd.get('data'));

      submitData({ name: 'status_save.php', data: fd }).then((response) => {
        //console.log('response',response)
        // @ts-ignore
        let res = response.data
        if (res && typeof res.status === 'boolean') {
          if (res.msg && res.msg.length > 0) {
            setDeepCloneData((prevData) =>
              prevData.map((item) => (selected.includes(String(item.id)) ? { ...item, status: targetmod } : item))
            )
            enqueueSnackbar(res.msg, { variant: res.status === true ? 'success' : 'error' })
          } else {
            enqueueSnackbar('Ошибка передачи данных', { variant: 'error' })
          }
        }
      })
    }
  }
  // --- send to other moderation multi-selected ---

  if (modInfo && modInfo[0]) {
    if (modInfo[0].firstname && modInfo[0].firstname.length > 0) {
      nameOfTable += ' - ' + modInfo[0].firstname
    }
  }
  let exportTarget = ''
  // console.log({ exId: exId, nameOfTable: nameOfTable })
  if (exId && exId > 0) {
    exportTarget = String(exId)
  } else {
    exportTarget = nameOfTable ? nameOfTable : 'moderation'
  }

  const isDateMatchingFilter = React.useCallback(
    (contactDate: string | null | undefined, filterDate: string) => {
      if (!filterDate || filterDate.trim() === '') return true

      const normFilter = normalizeDate(filterDate)
      if (!normFilter) return true

      const normContact = normalizeDate(contactDate)
      if (!normContact) return false

      return normContact === normFilter
    },
    []
  )

  const [order, setOrder] = React.useState<Order>(defaultOrder)
  const isModerationTable =
    !nameOfTable || nameOfTable.toLowerCase().includes('модера') || nameOfTable.toLowerCase().includes('moder')
  const [date, setDate] = React.useState<string>(() => {
    if (isModerationTable) {
      return localStorage.getItem('generalDate') ?? ''
    }
    return ''
  })
  const [contactDateDrafts, setContactDateDrafts] = React.useState<Record<string, string>>({})
  const [orderBy, setOrderBy] = React.useState<keyof Data>(defaultOrderBy)

  React.useEffect(() => {
    if (defaultOrderBy) {
      setOrderBy(defaultOrderBy)
    }
  }, [defaultOrderBy])

  React.useEffect(() => {
    if (defaultOrder) {
      setOrder(defaultOrder)
    }
  }, [defaultOrder])
  const [selected, setSelected] = React.useState<readonly string[]>([])
  const [submitData, {}] = useSubmitDataMutation()
  const [sendStat, {}] = useSubmitStatusMutation()
  const { enqueueSnackbar, closeSnackbar } = useSnackbar()
  const [page, setPage] = React.useState(0)
  const [rowsPerPage, setRowsPerPage] = React.useState(1200)
  const isFilterActive = Boolean(date && date.trim() !== '')

  const filteredData = React.useMemo(() => {
    if (!isFilterActive) return deepCloneData
    return deepCloneData.filter((obj) => {
      const rawVal = isModerationTable
        ? obj.next_contact_date
        : (obj.reg_date || obj.registermonth_new || obj.next_contact_date)
      return isDateMatchingFilter(rawVal, date)
    })
  }, [deepCloneData, date, isFilterActive, isModerationTable, isDateMatchingFilter])

  const activeList = isFilterActive ? filteredData : deepCloneData
  const indeterminate = selected.length > 0 && selected.length < activeList.length

  const onSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked && !indeterminate) {
      const newSelectedRecords = activeList.map((r) => String(r.id))
      setSelected(newSelectedRecords)
    } else {
      setSelected([])
    }
  }

  /*const sendExport = (id?: string, name?: any) => {
      let fD = new FormData();
      id && fD.append('val', id)
      switch (typeof name) {
          case 'object':
              fD.append('obj', name)
              break;
          case 'string':
              fD.append('export', name)
              break;
      }
      submitData({ name: 'export.php', data: fD })
      enqueueSnackbar('Данные успешно обновлены', {variant: 'success'})
  }*/
  const sendExport = (id?: string, name?: any) => {
    let and = false
    let urlData = ''
    if (id) {
      and = true
      urlData = '?id=' + id
    }
    switch (typeof name) {
      case 'object':
        and ? (urlData += '&obj=' + name) : (urlData += '?obj=' + name)
        break
      case 'string':
        and ? (urlData += '&export=' + name) : (urlData += '?export=' + name)
        break
    }
    //console.log('dlcsv', '/api/export.php'+urlData)
    let token = getCookie('token')
    if (token) {
      dlcsv('https://astrodating.ru/api/export.php' + urlData, token)
    }
  }

  function dlcsv(href: string, token: string) {
    fetch(href, {
      method: 'GET',
      headers: {
        'Content-Type': 'text/csv',
        Authorization: 'Bearer ' + token,
      },
    })
      .then((response) => response.blob())
      .then((blob) => {
        // Create blob link to download
        const url = window.URL.createObjectURL(new Blob([blob]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `people.xlsx`)
        document.body.appendChild(link) // Append to html link element page
        link.click() // Start download
        // @ts-ignore
        link.parentNode.removeChild(link) // Clean up and remove the link
      })
  }

  const updateSetter = (setterName: string, value: string, id: string) => {
    let fD = new FormData()
    fD.append('value', value)
    fD.append('setterName', setterName)
    fD.append('id', id)
    submitData({ name: 'setter.php', data: fD })
    setDeepCloneData((prevData) =>
      prevData.map((item) => (String(item.id) === String(id) ? { ...item, [setterName]: value } : item))
    )
  }
  const sendStatus = (id: string, value: string, _arr?: Data[], _ind?: number, key?: string) => {
    let fD = new FormData()
    fD.append('id', id)
    fD.append('status', value)
    key && fD.append('key', key)
    sendStat(fD)
    enqueueSnackbar('Данные успешно обновлены', { variant: 'success' })
    setDeepCloneData((prevData) => prevData.filter((item) => String(item.id) !== String(id)))
    setSelected((prevSelected) => prevSelected.filter((selectedId) => selectedId !== String(id)))
  }
  const sendData = async (id: string, value: string, name: string) => {
    let fD = new FormData()
    fD.append('id', id)
    fD.append('value', value)
    submitData({ name: name, data: fD })
    enqueueSnackbar('Данные успешно обновлены', {
      variant: 'success',
    })
  }
  const handleSaveContactDate = (id: string, customVal?: string) => {
    const rowId = String(id)
    const currentRow = deepCloneData.find((item) => String(item.id) === rowId)
    const valToSave =
      customVal !== undefined
        ? customVal
        : (contactDateDrafts[rowId] !== undefined ? contactDateDrafts[rowId] : (currentRow?.next_contact_date ?? ''))

    sendData(rowId, valToSave, 'updateNextContactData.php')

    setDeepCloneData((prevData) =>
      prevData.map((item) => (String(item.id) === rowId ? { ...item, next_contact_date: valToSave } : item))
    )

    setContactDateDrafts((prev) => {
      const next = { ...prev }
      delete next[rowId]
      return next
    })

    if (date && !isDateMatchingFilter(valToSave, date)) {
      setSelected((prev) => prev.filter((selectedId) => selectedId !== rowId))
    }
  }
  const handleClick = (event: React.MouseEvent<unknown>, name: string) => {
    const selectedIndex = selected.indexOf(name)
    let newSelected: readonly string[] = []

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name)
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1))
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1))
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1))
    }

    setSelected(newSelected)

    let fD = new FormData()

    fD.append('obj', JSON.stringify(newSelected))
    submitData({ name: 'export.php', data: fD })
    setSelected(newSelected)

    enqueueSnackbar('Данные успешно обновлены', {
      variant: 'success',
    })
  }
  const handleSelect = (event: React.MouseEvent<unknown>, name: string) => {
    const selectedIndex = selected.indexOf(name)
    let newSelected: readonly string[] = []

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name)
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1))
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1))
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1))
    }

    setSelected(newSelected)
    /*
            let fD = new FormData();

            fD.append('obj', JSON.stringify(newSelected))
            submitData({ name: 'export.php', data: fD })
            setSelected(newSelected);

            enqueueSnackbar('Данные успешно обновлены', {
                variant: 'success',
            })*/
  }
  const handleRequestSort = (event: React.MouseEvent<unknown>, property: keyof Data) => {
    const isAsc = orderBy === property && order === 'asc'
    setOrder(isAsc ? 'desc' : 'asc')
    setOrderBy(property)
  }
  const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      const newSelecteds = activeList.map((n) => String(n.id))
      setSelected(newSelecteds)
      return
    }
    setSelected([])
  }
  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage)
  }
  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  const isSelected = (name: string) => selected.indexOf(name) !== -1
  const getModerationName = (status: string | number | boolean) => {
    let name = 'unknown'
    switch (status) {
      case '-2':
        name = 'Удален'
        break
      case '0':
        name = 'Линия_1'
        break
      case '1':
      case '2':
      case '3':
      case '4':
      case '5':
      case '6':
      case '7':
      case '8':
      case '9':
        name = 'Мод_' + status
        break
      case '10':
        name = 'Модерация'
        break
      case '29':
        name = 'Общая база'
        break
      case '30':
        name = 'Архив'
        break
      case '32':
        name = 'Корзина'
        break
      case '49':
        name = 'РукДОК'
        break
      case '50':
        name = 'ДОК'
        break
      case '51':
        name = 'Док_1'
        break
      case '52':
        name = 'Док_2'
        break
      case '53':
        name = 'Док_3'
        break
      case '54':
        name = 'Док_4'
        break
      case '55':
        name = 'Док_5'
        break
      case '56':
        name = 'Док_6'
        break
      case '57':
        name = 'Док_7'
        break
      case '58':
        name = 'Док_8'
        break
      case '59':
        name = 'Док_9'
        break
    }
    return name
  }

  const handleExportExcel = () => {
    let toExport: Data[] = []
    let exportReason = ''

    if (selected.length > 0) {
      const selectedSet = new Set(selected.map(String))
      toExport = deepCloneData.filter((row) => selectedSet.has(String(row.id)))
      exportReason = `выделенные (${toExport.length} шт.)`
    } else if (isFilterActive) {
      toExport = filteredData
      exportReason = `по фильтру (${toExport.length} шт.)`
    } else {
      toExport = deepCloneData
      exportReason = `вся таблица (${toExport.length} шт.)`
    }

    if (toExport.length === 0) {
      enqueueSnackbar('Нет данных для экспорта', { variant: 'warning' })
      return
    }

    const sortedData = [...toExport].sort(getComparator(order, orderBy))

    const exportRows = sortedData.map((row) => ({
      ID: row.id,
      'Имя и фамилия': row.firstname || '',
      Пол: row.gender === '1' ? 'Мужской' : row.gender === '2' ? 'Женский' : row.gender || '',
      'Дата рождения': row.birthday || '',
      'В год кого': row.birthyear || '',
      'Знак зодиака': row.zodiak || '',
      'Основной язык любви': row.langlove || '',
      'Второй язык любви': row.langlove2 || '',
      VIP: row.vip == '1' ? 'Да' : row.vip == '0' ? 'Нет' : (row.vip ?? ''),
      Телефон: row.phone || '',
      VK: row.vk || '',
      'Контрольная дата контакта': row.next_contact_date || '',
      'Раздел / Статус': getModerationName(row.status) || row.status || '',
      'Дата регистрации': row.reg_date || '',
      'Последнее изменение': row.lastmodify || '',
      Источник: row.source_type || '',
      'Откуда узнали': row.source || '',
      Отложено: row.defer == '1' ? 'Да' : 'Нет',
      Город: row.city || '',
      Email: row.email || '',
    }))

    const worksheet = XLSX.utils.json_to_sheet(exportRows)
    worksheet['!cols'] = [
      { wch: 8 }, // ID
      { wch: 26 }, // Имя и фамилия
      { wch: 10 }, // Пол
      { wch: 14 }, // Дата рождения
      { wch: 14 }, // В год кого
      { wch: 14 }, // Знак зодиака
      { wch: 22 }, // Основной язык любви
      { wch: 22 }, // Второй язык любви
      { wch: 8 }, // VIP
      { wch: 18 }, // Телефон
      { wch: 28 }, // VK
      { wch: 26 }, // Контрольная дата контакта
      { wch: 18 }, // Раздел / Статус
      { wch: 18 }, // Дата регистрации
      { wch: 22 }, // Последнее изменение
      { wch: 16 }, // Источник
      { wch: 20 }, // Откуда узнали
      { wch: 10 }, // Отложено
      { wch: 18 }, // Город
      { wch: 24 }, // Email
    ]

    const workbook = XLSX.utils.book_new()
    const sheetTitle = (nameOfTable || 'Модерация').slice(0, 31)
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetTitle)

    const safeName = (nameOfTable || 'moderation').replace(/[^a-zA-Z0-9а-яА-ЯёЁ_-]/g, '_')
    const dateStr = dayjs().format('YYYY-MM-DD_HH-mm')
    const fileName = `${safeName}_${dateStr}.xlsx`

    XLSX.writeFile(workbook, fileName)

    enqueueSnackbar(`Экспортировано в Excel: ${exportReason}`, { variant: 'success' })
  }

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - filteredData.length) : 0
  const role = String(getCookie('role'))
  const memoizedRenderTable = React.useCallback(() => {
    return filteredData
      .slice()
      .sort(getComparator(order, orderBy))
      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
      .map((row, index, thisArr) => {
        const isItemSelected = isSelected(row.id)
        // Cannot access 'role' before initialization
        return (
          <TableRow
            hover
            role="checkbox"
            aria-checked={isItemSelected}
            tabIndex={-1}
            key={row.id}
            selected={isItemSelected}
            sx={
              row.tariff == '14'
                ? { backgroundColor: '#FFDE21', '& > td': { padding: '1px 4px' } }
                : { '& > td': { padding: '1px 4px' } }
            }
          >
            <TableCell
              align="left"
              sx={{
                maxWidth: '300px',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                paddingLeft: '10px !important',
              }}
              title={row.firstname}
            >
              {row.firstname}
            </TableCell>
            <TableCell align="left">{row.birthday}</TableCell>
            <TableCell align="left">{row.birthyear}</TableCell>
            <TableCell align="left">{row.zodiak}</TableCell>
            <TableCell align="left">{row.langlove}</TableCell>
            <TableCell align="left">{row.langlove2}</TableCell>
            {/*<TableCell
                            align="left"
                            sx={row.vip !== '0' ? { color: 'orange' } : null}
                            onClick={(e) => {
                                const vip = +row.vip ? '0' : '1'
                                row.vip = +row.vip ? '0' : '1'
                                e.currentTarget.style.color = +row.vip ? 'rgba(0, 0, 0, 0.87)' : 'orange'                                
                                updateSetter('vip', vip, row.id)
                            }}
                                // sendStatus(row.id, +row.vip ? '0' : '1', thisArr, index, 'vip')}
                        >
                            <StarIcon />
                        </TableCell>*/}
            <TableCell
              align="left"
              sx={vipStatus(row.tariff.toString()) ? { color: 'orange' } : null}
              // sendStatus(row.id, +row.vip ? '0' : '1', thisArr, index, 'vip')}
            >
              <StarIcon />
            </TableCell>
            <TableCell align="left" size="small" sx={{ minWidth: '125px' }}>
              <PhoneLink phone={row.phone} />
            </TableCell>
            <TableCell align="left" size="small">
              <a href={row.vk} target="_blank">
                <Avatar src="/images/vk.svg" alt="vk img" />
              </a>
            </TableCell>
            <TableCell align="left" size="small">
              <a href={row.vk} target="_blank">
                {row.vk}
              </a>
            </TableCell>
            <TableCell align="left" size="small">
              <Link to={`../profile/${row.id}`}>
                <EditIcon />
              </Link>
            </TableCell>
            <TableCell align="left" size="small" sx={{ py: 0.5, whiteSpace: 'nowrap' }}>
              {(() => {
                const rowId = String(row.id)
                const rawVal =
                  contactDateDrafts[rowId] !== undefined ? contactDateDrafts[rowId] : (row.next_contact_date ?? '')
                const inputVal = rawVal
                  ? rawVal.split(' ')[0].includes('.')
                    ? rawVal.split(' ')[0].split('.').reverse().join('-')
                    : rawVal.split(' ')[0]
                  : ''
                return (
                  <TextField
                    size="small"
                    type="date"
                    sx={{
                      width: 140,
                      '& .MuiInputBase-input': {
                        py: 0.6,
                        px: 1,
                        fontSize: '0.8125rem',
                      },
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 1.5,
                        bgcolor: '#ffffff',
                      },
                    }}
                    value={inputVal}
                    onChange={(e) => {
                      const val = e.target.value.trim()
                      handleSaveContactDate(rowId, val)
                    }}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        e.preventDefault()
                        handleSaveContactDate(rowId, (e.target as HTMLInputElement).value.trim())
                      }
                    }}
                  />
                )
              })()}
            </TableCell>
            <TableCell align="center" size="small" sx={{ py: 0.5 }}>
              <IconButton
                size="small"
                color="primary"
                title="Сохранить дату контакта"
                sx={{
                  p: 0.75,
                  borderRadius: 1.5,
                  '&:hover': {
                    bgcolor: 'rgba(25, 118, 210, 0.08)',
                  },
                }}
                onClick={() => {
                  handleSaveContactDate(String(row.id))
                }}
              >
                <SaveIcon fontSize="small" />
              </IconButton>
            </TableCell>
            <TableCell align="left" size="small" onClick={() => sendStatus(row.id, '10', thisArr, index, 'status')}>
              <AccountBoxIcon />
            </TableCell>
            <TableCell
              align="left"
              size="small"
              className="table__link"
              onClick={() => sendStatus(row.id, '1', thisArr, index, 'status')}
              title="Модерация 1"
            >
              <SvgIcon component={Counter1} viewBox="0 -960 960 960" />
            </TableCell>
            <TableCell
              align="left"
              size="small"
              className="table__link"
              onClick={() => sendStatus(row.id, '2', thisArr, index, 'status')}
              title="Модерация 2"
            >
              <SvgIcon component={Counter2} viewBox="0 -960 960 960" />
            </TableCell>
            <TableCell
              align="left"
              size="small"
              className="table__link"
              onClick={() => sendStatus(row.id, '3', thisArr, index, 'status')}
              title="Модерация 3"
            >
              <SvgIcon component={Counter3} viewBox="0 -960 960 960" />
            </TableCell>
            <TableCell
              align="left"
              size="small"
              className="table__link"
              onClick={() => sendStatus(row.id, '4', thisArr, index, 'status')}
              title="Модерация 4"
            >
              <SvgIcon component={Counter4} viewBox="0 -960 960 960" />
            </TableCell>
            <TableCell
              align="left"
              size="small"
              className="table__link"
              onClick={() => sendStatus(row.id, '5', thisArr, index, 'status')}
              title="Модерация 5"
            >
              <SvgIcon component={Counter5} viewBox="0 -960 960 960" />
            </TableCell>
            <TableCell
              align="left"
              size="small"
              className="table__link"
              onClick={() => sendStatus(row.id, '6', thisArr, index, 'status')}
              title="Модерация 6"
            >
              <SvgIcon component={Counter6} viewBox="0 -960 960 960" />
            </TableCell>
            <TableCell
              align="left"
              size="small"
              className="table__link"
              onClick={() => sendStatus(row.id, '7', thisArr, index, 'status')}
              title="Модерация 7"
            >
              <SvgIcon component={Counter7} viewBox="0 -960 960 960" />
            </TableCell>
            <TableCell
              align="left"
              size="small"
              className="table__link"
              onClick={() => sendStatus(row.id, '8', thisArr, index, 'status')}
              title="Модерация 8"
            >
              <SvgIcon component={Counter8} viewBox="0 -960 960 960" />
            </TableCell>
            <TableCell
              align="left"
              size="small"
              className="table__link"
              onClick={() => sendStatus(row.id, '9', thisArr, index, 'status')}
              title="Модерация 9"
            >
              <SvgIcon component={Counter9} viewBox="0 -960 960 960" />
            </TableCell>
            {
              // Архив
              /*
          <TableCell align="left" size='small' className="table__link" onClick={() => sendStatus(row.id, '30', thisArr, index, 'status')}>
              <AccountBoxIcon />
          </TableCell>*/
            }
            <TableCell align="left" size="small">
              {getModerationName(row.status)}
            </TableCell>
            {
              // В корзину
              /*<TableCell align="left" size='small' onClick={() => sendStatus(row.id, '32', thisArr, index, 'status')} >
                  <RestoreFromTrashIcon fontSize="medium" />
              </TableCell>*/
            }
            {
              // Удалить
              /*<TableCell align="left" size='small' onClick={() => sendStatus(row.id, '-2', thisArr, index, 'status')} >
                  <DeleteOutlineIcon fontSize="medium" />
              </TableCell>*/
            }
            <TableCell align="left">{row.reg_date}</TableCell>
            <TableCell align="left">{row.lastmodify}</TableCell>
            <TableCell align="left">{row.source_type ? row.source_type : '-'}</TableCell>
            <TableCell align="left">{row.source ? row.source : '-'}</TableCell>
            <TableCell
              align="left"
              sx={{
                paddingLeft: '10px !important',
                ...(row.defer !== '0' ? { color: 'orange' } : null),
              }}
            >
              <CheckIcon
                onClick={(e) => {
                  const a = e.currentTarget.style.color
                  e.currentTarget.style.color = a === 'white' ? 'orange' : 'white'
                  updateSetter('defer', +row.defer ? '0' : '1', row.id)
                }}
              />
            </TableCell>
            <TableCell
              padding="checkbox"
              // onClick={(event) => subExport(event, row.id)}
              onClick={(event) => handleSelect(event, row.id)}
            >
              <Checkbox
                color="primary"
                checked={isItemSelected}
                inputProps={{
                  'aria-labelledby': `enhanced-table-checkbox-${index}`,
                }}
              />
            </TableCell>
          </TableRow>
        )
      })
  }, [filteredData, page, rowsPerPage, order, orderBy, selected, contactDateDrafts, handleSaveContactDate])

  let tableRefVariable = memoizedRenderTable()

  const mem = React.useCallback(() => {
    return filteredData.length
  }, [filteredData.length])

  function printExport(role: string, nameOfTable?: string) {
    if (
      role == 'ok_admin' ||
      role == 'ok_mainDok' ||
      (role == 'consideration' && (nameOfTable == 'Модерация' || nameOfTable == 'moderation'))
    ) {
      return (
        <Button variant="contained" size="large" onClick={handleExportExcel}>
          Экспортировать
        </Button>
      )
    }
  }

  return (
    <Box sx={{ mb: 4 }}>
      <Paper
        elevation={0}
        sx={{
          p: { xs: 1.5, sm: 2 },
          mb: 2.5,
          borderRadius: 2,
          border: '1px solid',
          borderColor: 'divider',
          bgcolor: '#ffffff',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            gap: 2,
          }}
        >
          <DatePicker
            label="Фильтр по дате"
            value={date ? dayjs(date) : null}
            format="DD.MM.YYYY"
            onChange={(newValue) => {
              const formatted = newValue && dayjs(newValue).isValid() ? dayjs(newValue).format('YYYY-MM-DD') : ''
              setDate(formatted)
              if (isModerationTable) {
                if (formatted) {
                  localStorage.setItem('generalDate', formatted)
                } else {
                  localStorage.removeItem('generalDate')
                }
              }
            }}
            slotProps={{
              textField: {
                size: 'small',
                sx: { width: { xs: '100%', sm: 220 } },
              },
              field: {
                clearable: true,
              },
            }}
          />

          <Chip
            label={`Сейчас в работе: ${filteredData.length}`}
            color="primary"
            variant="outlined"
            sx={{ fontWeight: 600, px: 0.5, height: 38, fontSize: '0.875rem' }}
          />

          <Divider orientation="vertical" flexItem sx={{ display: { xs: 'none', sm: 'block' } }} />

          <FormControlLabel
            control={
              <Checkbox
                indeterminate={indeterminate}
                checked={activeList.length > 0 && selected.length === activeList.length}
                onChange={onSelectAllClick}
                size="small"
              />
            }
            label="Выбрать всё"
            sx={{ m: 0, '& .MuiTypography-root': { fontSize: '0.875rem', fontWeight: 500 } }}
          />

          {printMenuItems(modId ? modId.toString() : null)}
        </Box>
      </Paper>

      <Paper
        elevation={0}
        sx={{
          maxWidth: '100%',
          mb: 2,
          borderRadius: 2,
          border: '1px solid',
          borderColor: 'divider',
          overflow: 'hidden',
          bgcolor: '#ffffff',
        }}
      >
        <EnhancedTableToolbar numSelected={selected.length} nameOfTable={nameOfTable} modInfo={modInfo} />
        <TableContainer sx={{ maxHeight: '750px' }}>
          <Table stickyHeader aria-label="sticky dense table" aria-labelledby="tableTitle" size="small">
            <EnhancedTableHead
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={activeList.length}
            />
            <TableBody>
              {tableRefVariable}
              {emptyRows > 0 && (
                <TableRow style={{ height: 33 * emptyRows }}>
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[1200, 20, 10, 5]}
          component="div"
          count={filteredData.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>

      {printExport(role, nameOfTable)}
    </Box>
  )
}

export default EnhancedTable
